const DAILY_BONUS_UP_TO_AMOUNTS_BY_INDEX = [0.5, 1, 2, 3, 4.5, 7, 8, 10, 15, 25];

export const getDailyBonusUpToByIndex = (index: number, fallback: number) => {
  return DAILY_BONUS_UP_TO_AMOUNTS_BY_INDEX[index] ?? fallback;
};
